import GridViewCollapase from "src/SharedComponents/GridViewCollapse/GridViewCollapse";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import { IPartner, IUserLicencesInfo } from "src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo";
import { useEffect, useState } from "react";
import { useSupportPermissions } from "src/Utils/Hooks/useGetAdminInfo/useSupportPermissions";
import { useDistributorLicenseServiceWrapper } from "src/Utils/Hooks/LicenseService/useDistributorLicenseServiceWrapper";
import { formatDateString } from "src/Utils/DateFormatting/DateFormatter";
import Button from "src/SharedComponents/Button/Button";
import AssignLicenseToPartner from "../../AssignLicenseToPartner/AssignLicenseToPartner";
import { LicenseType } from "src/Utils/Hooks/LicenseService/useDistributorLicenseService";
import CheckBox from "src/SharedComponents/CheckBox/CheckBox";
import { isDateExpired } from "src/Utils/DateExpiry/DateExpiryChecker";

export interface IAuraAppLicensesUnassigned{
    auraAppLicensesUnassigned: IUserLicencesInfo[];
    partners: IPartner[] | undefined;
    updateLicenses: () => void;
    updateUserLicenseCheckbox: (userLicense: IUserLicencesInfo, isSelected: boolean) => void;
    isChecked: (license: IUserLicencesInfo) => boolean;
    clearSelectedUserLicenses: () => void;
}

const AuraAppLicensesUnassigned: React.FC<IAuraAppLicensesUnassigned> = ({auraAppLicensesUnassigned, partners, updateLicenses, updateUserLicenseCheckbox, isChecked, clearSelectedUserLicenses}) => {
    const [showAssignPartner, setShowAssignPartner] = useState<boolean>(false);
    const [entitlementId, setEntitlementId] = useState<string>("");
    const { isSupportAdmin } = useSupportPermissions();
    const { reqestResponse, assignLicensePartner } = useDistributorLicenseServiceWrapper();
    
    const handleCheckboxChange = (userLicense: IUserLicencesInfo, checked: boolean) => {
        updateUserLicenseCheckbox(userLicense, checked);
    }

    const orderedLicenses = [
        ...auraAppLicensesUnassigned.filter(
          (license) => isChecked(license)
        ), // Selected licenses on top
        ...auraAppLicensesUnassigned.filter(
          (license) => !isChecked(license)
        ), // Unselected licenses below
    ];

    useEffect(() => {
        if(reqestResponse){
            updateLicenses();
            clearSelectedUserLicenses();
        }
    }, [reqestResponse, updateLicenses, clearSelectedUserLicenses]);

    return(
        <>
            {
                showAssignPartner && 
                <AssignLicenseToPartner
                    onClose={() => {setShowAssignPartner(false)}}
                    onSubmit={(distributorId: string, distributorName: string) => {
                        assignLicensePartner(LicenseType.AuraAppLicenses,distributorId, [entitlementId], distributorName);
                        setShowAssignPartner(false);
                    }}
                    entitlementId={entitlementId}
                    partners={partners}
                    licenseType="App License"
                />
            }
            <GridViewCollapase title="On Stock" id="aura-app-licenses-unassigned">
                <div>
                    <table style={{ width: '100%' }} data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                        <thead className={`${tableStyles.tableHead}`}>
                            <tr key={'header'}>
                                <th style={{width: '5%', paddingTop: '0px'}}></th>
                                <th className={tableStyles.heading} style={{width: '25%', paddingTop: '0px'}}>License Type</th>
                                <th className={tableStyles.heading} style={{width: '25%', paddingTop: '0px'}}>Expiration date</th>
                                <th className={tableStyles.heading} style={{width: '25%', paddingTop: '0px'}}>Seats</th>
                                <th style={{width: '25%', paddingTop: '0px'}}></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                orderedLicenses.map((license: IUserLicencesInfo, index: number) => (
                                    <tr key={index}>
                                        <td><CheckBox checked={isChecked(license)} onChange={(checked) => handleCheckboxChange(license, checked)}/></td>
                                        <td className={tableStyles.data}>{license?.licenseType}</td>
                                        <td className={tableStyles.data} style={isDateExpired(license?.licenseEndDate) ? {color: 'red'} : {}}>{license?.licenseType.toLowerCase().includes("permanent") ? '-' : (license?.licenseEndDate ? formatDateString(license?.licenseEndDate) : '-')}</td>
                                        <td className={tableStyles.data}>{license?.maximumSeats}</td>
                                        <td className={tableStyles.data}></td>
                                        <td className={tableStyles.data} style={{textAlign: 'end'}}>
                                            <Button
                                                backgroundColor="var(--primary-translucent)"
                                                color="var(--primary-color)"
                                                text="Assign to Partner"
                                                borderColor="none"
                                                fontSize="12px"
                                                width='172px'
                                                fontWeight='600'
                                                disable={!isSupportAdmin}
                                                onClick={() => {setEntitlementId(license?.entitlementId);setShowAssignPartner(true)}}
                                            />
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </GridViewCollapase>
        </>
    );
}

export default AuraAppLicensesUnassigned;